module.exports = __webpack_public_path__ + "img/9_ward_100.ad3442fb.png";